module.exports = "/images/alert-success.svg?f7f7c08a9d83a19fbb65a2d9975052a2";